export const SetUserType = (item, dispatch) => {
  console.log(1232);
  dispatch({
    type: "UPDATE_USERTYPE",
    item: item,
  });
  return item;
};
